import { getNextBusinessDay } from '@lib/utilities/date/getNextBusinessDay'
import { toZonedTime } from 'date-fns-tz'

/**
 * Determines the date to schedule a phone call based on the current time and the patient's timezone.
 * If the current time is after 11 AM, it schedules the call for the next business day.
 *
 * @param {string} [patientTimezone] - The patient's timezone in IANA format (e.g., "America/New_York").
 * If not provided, the user's browser timezone is used as a fallback.
 * @returns {Date} - The scheduled date for the phone call in UTC.
 */
export function getDateToScheduleCallUTC({
  currentDate,
  patientTimezone,
}: {
  currentDate?: Date
  patientTimezone?: string
}): Date {
  const now = currentDate ?? new Date()
  let dateToScheduleCall = patientTimezone
    ? toZonedTime(now, patientTimezone)
    : toZonedTime(now, Intl.DateTimeFormat().resolvedOptions().timeZone) // fallback to user's browser timezone

  // If the current time is after 11 AM, schedule the call for the next business day
  if (dateToScheduleCall.getHours() >= 11) {
    dateToScheduleCall = getNextBusinessDay(now)
  }

  return toZonedTime(dateToScheduleCall, 'UTC')
}
